import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import SpecialChecks from './SpecialChecks';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import { Form, SpecialOverallForm, FormData } from '../../../models/SpecialsData';

interface SpecialChecksContainerProps {
  doNumber: string;
  awbCode: string;
  awbNumber: string;
  receiveError: Function;
  checkElement: (check: boolean) => JSX.Element;
  setSpecialStatus: (specialStatus: boolean) => void;
  onlyRead?: boolean;
  deliveredDate: string;
  awbVer: number;
};

interface SpecialChecksContainerState {
  specialsChecks: SpecialOverallForm;
  ver: number;
  doNumber: string;
  awbCode: string;
  awbNumber: string;
  disableApi: boolean;
  awbVer: number;
};

class SpecialChecksContainer extends Component<SpecialChecksContainerProps, SpecialChecksContainerState> {

  state = {
    specialsChecks: {
      special_form_data: {
        specials_form_ver: -1,
        specials_form_data: [],
        other: {
          color: '#fffff',
          name: []
        }
      },
      special_form_ver: -1,
      specials_form: {
        form: [],
        other: []
      }
    },
    ver: -1,
    awbVer: -1,
    doNumber: '',
    awbCode: '',
    awbNumber: '',
    disableApi: false
  };

  componentDidMount() {

    const doNumber: string = this.props.doNumber;
    const awbCode: string = this.props.awbCode;
    const awbNumber: string = this.props.awbNumber;
    const awbVer: number = this.props.awbVer;

    if (doNumber && awbCode && awbNumber) {

      this.setState({ doNumber, awbCode, awbNumber, awbVer });
      this.loadOrPostData('load', doNumber, awbCode, awbNumber, awbVer);
    }
  }

  componentDidUpdate(prevProps: SpecialChecksContainerProps) {

    const doNumber: string = this.props.doNumber;
    const awbCode: string = this.props.awbCode;
    const awbNumber: string = this.props.awbNumber;
    const awbVer: number = this.props.awbVer;

    if (prevProps.doNumber !== doNumber && prevProps.awbNumber !== awbNumber) {

      this.setState({ doNumber, awbCode, awbNumber, awbVer });
      this.loadOrPostData('load', doNumber, awbCode, awbNumber, awbVer);
    }
  }

  loadOrPostData = (type: string, doNumber: string, code: string, number: string, awbVer: number, form?: any): void => {

    this.setState({ disableApi: true }, () => {
      let data: any = {
        specials_form_ver: -1,
        specials_form_data: {
          specials_form_data: [],

          other: {
            color: '#fffff',
            name: ''
          }
        },

      };

      if (form) {
        data = {
          specials_form_ver: form.specials_form_ver,
          specials_form_data: form
        };
      }

      const result: Promise<ApiResponse<SpecialOverallForm>> =
        (type === 'load') ? pickupOrderRemote.getGhaPoAwbSpecialChecks(doNumber, code, number, awbVer) : pickupOrderRemote.updateGhaPoAwbSpecialsChecks(doNumber, code, number, awbVer, data);

      result.then((resp: ApiResponse<SpecialOverallForm>) => {

        const result: SpecialOverallForm | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (result) {

          let specialsChecks = { ...result };
          if (!specialsChecks.special_form_data) {

            const specials_form_ver: number = specialsChecks.special_form_ver;
            const specials_form_data: Array<FormData> = [];
            const other = {
              color: '#fffff',
              name: []
            }

            specialsChecks.specials_form.form.map((val: Form) => {
              specials_form_data.push(val.default_value)
            }
            );

            specialsChecks.special_form_data = {
              specials_form_ver,
              specials_form_data,
              other
            };
          } else {
            if (specialsChecks.special_form_data) {
              let status = false;
              specialsChecks.special_form_data.specials_form_data.forEach(val => {
                if (val.value) {
                  status = true;
                }
              });
              if (specialsChecks.special_form_data.other.name.length) {
                status = true
              }
              if (!Array.isArray(specialsChecks.special_form_data.other.name)) {
                specialsChecks.special_form_data.other.name = [];
              }
              this.props.setSpecialStatus(status);
            }
          }

          this.setState({ specialsChecks, ver: specialsChecks.special_form_ver, disableApi: false });
        }

        if (error) {
          this.props.receiveError(error);
        }
      });
    });

  }

  handleChange = (event: any, type: string, id?: number): void => {

    if (this.props.deliveredDate === null) {
      const value: any = event.target.value;
      const formData: Array<FormData> = [...this.state.specialsChecks.special_form_data.specials_form_data];
      let otherForm = { ...this.state.specialsChecks.special_form_data.other };
      if (type === 'block' && (id || id == 0) && !formData[id].temp) {
        formData[id].value = !formData[id].value;
      }
      else if (type === 'other') {
        otherForm.name = value;
      } else if (type === 'none' && id && formData[id].temp && !value) {
        formData[id].temp = '';
        formData[id].value = false;
      } else if (type === 'none' && id && value) {
        formData[id].value = true;
        formData[id].temp = value;
      }
      const specialsChecks: any = { ...this.state.specialsChecks };
      specialsChecks.special_form_data.specials_form_data = formData;
      specialsChecks.special_form_data.other = otherForm;

      this.setState({ specialsChecks });

      this.loadOrPostData('post', this.state.doNumber, this.state.awbCode, this.state.awbNumber, this.state.awbVer, specialsChecks.special_form_data);

    }

  };

  render() {

    return (
      <SpecialChecks
        specialChecks={ this.state.specialsChecks }
        handleChange={ this.handleChange }
        checkElement={ this.props.checkElement }
        awbCode={ this.state.awbCode }
        onlyRead={ this.props.onlyRead }
        deliveredDate={ this.props.deliveredDate }
        disableApi={ this.state.disableApi }
      />
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
}

export default connect(null, mapDispatchToProps)(SpecialChecksContainer);